import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../common/CCUtils"
import { COLOR } from "../../../common/Color"
import { TransitionState } from "../../GameState"
import { Buttons } from "../../generic-sprites/Buttons"
import { ColorUtils } from "../../utils/ColorUtils"
import { PhaserUtils } from "../../utils/PhaserUtils"
import { Scale } from "../../utils/Scale"
import {
    TestimonialOutroInfo,
    Testimonials,
    VideoInfo,
} from "../../utils/TestimonialOutro"
import { Videos } from "../../utils/Videos"
import { WomExitAssets } from "./WheelOfMisfortuneAssets"

export class WheelOfMisfortuneExit extends Phaser.State {
    constructor(
        private videoKey?: string,
        private testimonialIntroAudio?: string,
    ) {
        super()
    }

    preload() {
        const load = PhaserUtils.makeLoader(
            this.game,
            "wheel-of-misfortune/transitions/testimonials",
        )

        this.testimonialIntroAudio =
            CCUtils.genderifyFileName(`testimonials.mp3`)
        load.audio(
            WomExitAssets.BUDDY_TESTIMONIALS_INTRO,
            this.testimonialIntroAudio,
        )

        load.image(WomExitAssets.TESTIMONIAL_1_IMAGE, "testimonial-1.png")
        load.image(WomExitAssets.TESTIMONIAL_2_IMAGE, "testimonial-2.png")
        load.image(WomExitAssets.TESTIMONIAL_3_IMAGE, "testimonial-3.png")

        load.video(WomExitAssets.TESTIMONIAL_1, "testimonial-1.mp4")
        load.video(WomExitAssets.TESTIMONIAL_2, "testimonial-2.mp4")
        load.video(WomExitAssets.TESTIMONIAL_3, "testimonial-3.mp4")

        const videoLocation = CCUtils.asset(
            CCUtils.genderifyFileName(
                `wheel-of-misfortune/transitions/outro.mp4`,
            ),
        )
        this.videoKey = WomExitAssets.OUTRO1
        this.game.load.video(this.videoKey, videoLocation)
    }

    async create() {
        await PhaserUtils.sharedCreateFunctions(this.game)
        Scale.resizeScreen(this.game, true)
        ColorUtils.setBackgroundColor(this.game, COLOR.black)

        const outroInfo = new TestimonialOutroInfo()

        outroInfo.testimonialIntroAudio = WomExitAssets.BUDDY_TESTIMONIALS_INTRO
        outroInfo.testimonials = [
            new VideoInfo(
                WomExitAssets.TESTIMONIAL_1_IMAGE,
                WomExitAssets.TESTIMONIAL_1,
            ),
            new VideoInfo(
                WomExitAssets.TESTIMONIAL_2_IMAGE,
                WomExitAssets.TESTIMONIAL_2,
            ),
            new VideoInfo(
                WomExitAssets.TESTIMONIAL_3_IMAGE,
                WomExitAssets.TESTIMONIAL_3,
            ),
        ]
        outroInfo.goTo = TransitionState.WHEEL_EXIT2

        const videoGroup = this.game.add.group()
        await Videos.add(this.game, this.videoKey, {
            onComplete: () => {
                Buttons.create(
                    this.game,
                    "Next",
                    () => {
                        videoGroup.destroy()
                        Testimonials.showTestimonials(
                            this.game,
                            outroInfo,
                            "Click on the pictures to listen to what people have to say about being addicted.",
                        )
                    },
                    {
                        x: Scale.x(0.84),
                        y: Scale.y(0.9),
                        group: videoGroup,
                    },
                )
            },
            group: videoGroup,
            fillScreen: true,
        })
    }
}
